module.exports = __webpack_public_path__ + "images/xl_anhui.jpg?10677793f8da07d3d0e768d10a9e0925";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_anhui.jpg
// module id = 225
// module chunks = 1